













































import Vue, { PropType } from "vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Rates from "@/components/Molecules/Rates/index.vue";
import FollowButton from "@/components/Molecules/FollowButton/index.vue";
import CompanyLogo from "@/components/Atoms/CompanyLogo/index.vue";
import { numberWithCommas } from "@/helpers/format-helper";

import { ApiResponse } from "@/api/types";
import { addFollowCompanies, removeFollowCompanies } from "@/api";

export interface Data {
  isFollow: boolean;
  loading: boolean;
}
export interface Computed {
  likedCountText: string;
  experienceCountText: string;
}
export interface Props {
  defaultIsFollow: boolean;
  company: ApiResponse.CompanyWithLikeCount;
}
export interface Methods {
  onChildMouseover: () => void;
  onChildMouseout: () => void;
  handleClickFollow: (data: { isFollow: Data["isFollow"] }) => void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "SettingsFollowsCompaniesCompanyCard",
  components: {
    Heading,
    Rates,
    FollowButton,
    CompanyLogo
  },
  props: {
    defaultIsFollow: {
      type: Boolean as PropType<Props["defaultIsFollow"]>,
      default: true
    },
    company: {
      type: Object as PropType<Props["company"]>,
      required: true
    }
  },
  data() {
    return {
      isFollow: true,
      loading: false
    };
  },
  computed: {
    likedCountText() {
      return `${numberWithCommas(this.company.like_count)}名の学生がお気に入り`;
    },
    experienceCountText() {
      return this.company.report_count
        ? `${numberWithCommas(this.company.report_count)}件`
        : "0件";
    }
  },
  mounted() {
    this.isFollow = this.defaultIsFollow;
  },
  methods: {
    onChildMouseover() {
      this.$el.classList.add("companyCard--childEvent");
    },
    onChildMouseout() {
      this.$el.classList.remove("companyCard--childEvent");
    },
    async handleClickFollow({ isFollow }) {
      try {
        this.loading = true;
        this.isFollow = isFollow;
        if (isFollow) {
          await addFollowCompanies({ company_ids: [this.company.id] });
        } else {
          await removeFollowCompanies({ company_ids: [this.company.id] });
        }
      } catch {
        this.isFollow = !isFollow;
      } finally {
        this.loading = false;
      }
    }
  }
});
